<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md"
                   :visible="modal.show"
                   :data="model"
                   :title="model.uuid ? $t('Edit Clerk') : $t('Add Clerk')"
                   @hidden="onHidden"
                   @show="onShow"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <div class="row">
        <div class="col-md-12">
          <input-widget :autofocus="true" @keyup="validateClerkName()" @blur="validateClerkName()" :model="model"
                        attribute="name" :placeholder="$t('Clerk Name')"/>
        </div>
        <div class="col-md-12">
          <input-widget type="select2"
                        :items="availableLanguages"
                        :model=model
                        attribute="language_uuid"
                        display-field="${item.name}"
                        value-field="uuid"/>
        </div>
        <!--        <div class="col-md-12 clerk-language-select">-->
        <!--          <input-widget type="select2"-->
        <!--                        :items="availableLanguages"-->
        <!--                        :model=model-->
        <!--                        attribute="language"-->
        <!--                        display-field="${item.name}"-->
        <!--                        value-field="uuid"-->
        <!--                        @select2Select="getSelectedLanguages()"-->
        <!--                        :disabled="!availableLanguages.length"/>-->
        <!--          <ul v-if="selectedLanguages.length > 0" class="list-inline d-inline-block mb-2">-->
        <!--            <li v-for="tag in selectedLanguages" :key="tag.uuid" class="list-inline-item">-->
        <!--              <b-form-tag-->
        <!--                size="lg"-->
        <!--                @remove="removeTag(tag)"-->
        <!--                variant="primary"-->
        <!--              >{{ tag.name }}-->
        <!--              </b-form-tag>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </div>-->
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import Clerk from "./Clerk.model";
  import i18n from "@/shared/i18n";
  import _ from 'lodash'
  import {SOURCE_TELEPHONE_BIDS_TABLE} from "@/modules/constants";

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');


  export default {
    name: "ClerksModal",
    components: {
      InputWidget,
      ArtisioModal,
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new Clerk(),
        selectedLanguages: [],
        languages: [],
      }
    },
    computed: {
      ...mapState({
        modal: state => state.clerksModal,
        clerks: state => state.clerksModal.object.clerks,
        editObject: state => state.clerksModal.object,
        branchLanguages: state => state.selectedBranch.languages ? state.selectedBranch.languages : [],
      }),
      ...mapStateGlobal({
        currentBranchLanguages: state => state.currentUser.branch.languages
      }),
      availableLanguages() {
        return this.languages.filter(opt => this.selectedLanguages.map(sl => sl.uuid).indexOf(opt.uuid) === -1)
      },
      isDuplicateName() {
        return this.clerks ? this.clerks.filter(cl => cl.uuid !== this.modal.object.uuid).some(c => c.name === this.model.name) : false
      }
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new Clerk(this.editObject)
          // this.selectedLanguages = [...this.editObject.languages]
          if (this.editObject.languages && this.editObject.languages.length > 0) {
            this.model.language_uuid = this.editObject.languages[0].uuid
            this.model.language = this.editObject.languages
          }
        }
        if (this.modal.source === SOURCE_TELEPHONE_BIDS_TABLE) {
          this.languages = this.currentBranchLanguages
        } else {
          this.languages = this.branchLanguages
        }
      }
    },
    methods: {
      ...mapActions(['hideClerksModal', 'createClerk', 'updateClerk']),
      onShow() {
        this.showConfirmation = true;
        if (!this.modal.object.name) {
          this.createDefaultClerkName();
        }
      },
      onHidden() {
        this.model = new Clerk();
        this.selectedLanguages = [];
        this.hideClerksModal();
      },
      async onSubmit() {
        this.validateClerkName();
        if (this.isDuplicateName) return;
        let data = {
          name: this.model.name,
          language_uuids: this.model.language_uuid ? [this.model.language_uuid] : [],
          languages: [this.model.language],
          branch_uuid: this.modal.object.branch_uuid,
        }
        let response = null;
        this.loading = true;

        if (!this.model.uuid) {
          response = await this.createClerk(data);
        } else {
          response = await this.updateClerk({...data, uuid: this.modal.object.uuid});
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideClerksModal();
          this.$toast('success', this.model.uuid ? this.$t('Clerk successfully updated') : this.$t('Clerk successfully added'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            if (response.body.non_field_errors) {
              this.$errorDialog(response.body.non_field_errors[0]);
            } else {
              this.model.setMultipleErrors(response.body);
            }
          }
        }
      },
      createDefaultClerkName() {
        let clerkNameInts = []
        const regex = (/[cC]{1}[lL]{1}[eE]{1}[rR]{1}[kK]{1}\s(\d{1,3})/);
        let intForClerkName = 1;

        if (this.clerks.length) {
          this.clerks.forEach((c) => {
            if (c.name.match(regex)) {
              clerkNameInts.push(parseInt(c.name.match(regex)[1]));
            }
          })

          if (clerkNameInts.length > 0) {
            intForClerkName = Math.max(...clerkNameInts) + 1
          }
        }

        this.model = new Clerk({
          ...this.model,
          name: `${i18n.t('Clerk')} ${(this.clerks ? intForClerkName : '')}`
        })
      },
      validateClerkName() {
        this.model.resetErrors('name')
        if (this.model.name && this.isDuplicateName) {
          this.model.setErrors('name', [this.$i18n.t('Clerk name already exists')])
        }
      },
      removeTag(tag) {
        this.selectedLanguages = _.remove(this.selectedLanguages, l => l.uuid !== tag.uuid)
        if (!this.selectedLanguages.length) {
          this.model.language = '';
        }
      },
      getSelectedLanguages() {
        let langId = this.model.language;
        this.selectedLanguages.push(this.languages.find(l => l.uuid === langId))
      }
    }
  }
</script>

<style scoped>
  #tags-component-select.form-control {
    border: none;
    padding: 0;
  }

  /deep/ .clerk-language-select .form-group {
    margin-bottom: 0.5rem;
  }

</style>
